export default __webpack_public_path__ + "static/media/mountain5.de32fc7f.png";